const initGoogleClickIdentifierSession = (): void => {
  const gclid = new URLSearchParams(window.location.search).get('gclid')

  if (gclid) window.sessionStorage.setItem('gclid', gclid)
}

export { initGoogleClickIdentifierSession }
